'use strict';

(function() {
  angular
    .module('specsguardApp')
    .directive('widgetProjectLog', widgetProjectLog);

  function widgetProjectLog () {
    return {
      restrict: 'E',
      templateUrl: 'app-legacy/project/overview/widgets/log/widget-project-log.tmpl.html',
      controller: 'widgetProjectLogCtrl',
      controllerAs: '$widgetProjectLogCtrl',
      scope: true,
    };
  }
})();
